import TitledTextWithBadges from "@coworker/apprestructured/src/task-management/components/TitledTextWithBadges/TitledTextWithBadges";
import {
  getTypedValue,
  validateStringType,
} from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { safeGetByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import { ViewerFragmentCommonProps } from "../ViewerFragment";

type ViewerBadge = {
  label: string;
  value: string;
};

export type TitledTextWithBadgesViewerFragmentConfigProps = {
  titleField: string;
  textField?: string;
  badgesField?: string;
  shouldTranslateTitle?: boolean;
  shouldTranslateBadges?: boolean;
};

type TitledTextWithBadgesViewerFragmentProps = {
  configProps: TitledTextWithBadgesViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function TitledTextWithBadgesViewerFragment({
  configProps,
  commonProps,
}: TitledTextWithBadgesViewerFragmentProps) {
  const {
    titleField,
    textField,
    badgesField,
    shouldTranslateTitle = false,
    shouldTranslateBadges = false,
  } = configProps;
  const { task } = commonProps;
  const { t } = useTranslation();

  const rawTitle = safeGetByPath(task, titleField);
  const rawText = textField ? safeGetByPath(task, textField) : undefined;
  const rawBadges = badgesField ? safeGetByPath(task, badgesField) : [];

  const title = getTypedValue<string>(rawTitle);
  const text = textField ? validateStringType(rawText) : undefined;
  const badges = getTypedValue<ViewerBadge[]>(rawBadges);

  if (isLoading(title) || isLoading(text) || isLoading(badges)) {
    return null;
  }

  if (!title) {
    return null;
  }

  const badgeLabels = Array.isArray(badges)
    ? badges.map((badge) =>
        shouldTranslateBadges ? t(badge.label) : badge.label
      )
    : [];
  const displayText = text || "";

  return (
    <TitledTextWithBadges
      title={shouldTranslateTitle ? t(title) : title}
      text={displayText}
      badges={badgeLabels}
    />
  );
}

export default TitledTextWithBadgesViewerFragment;
